import { useState, useEffect, useRef } from 'react';
import { Header } from '../../common/Header/Header.jsx';
import { MultipleAffiliationTable } from '../../common/Tables/Tables';
import { multipleRenewalTableHeader } from '../../../assets/helpers/tables';
import { notify } from '../../../assets/helpers/toast';
import { membershipService } from '../../../services/membershipService';
import { customerService } from '../../../services/customerService';
import { giftCardService } from '../../../services/giftCardService';
import { discountService } from '../../../services/discountService';
import authService from '../../../services/authService';
import { vehicleService } from '../../../services/vehicleService';
import { economicActivitiesService } from '../../../services/economicActivitiesService';
import { currencyRateService } from '../../../services/currencyRateService';
import { saleChannelService } from '../../../services/saleChannelService';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';
import * as schemas from '../../../assets/schemas/schemas';
import { salesRoles, casheaLinkAllowedRoles } from '../../../assets/helpers/roles';
import {
  EditClientModal,
  EditRCVModal,
  CartModal,
} from '../../common/Modals/Modals.jsx';
import {
  phoneCodes,
  idCodes,
  genderOptions,
  civilStateOptions,
  KMServiceOptions,
  KMOderOptions,
  planAllowsUnlimitedTow,
  rcvOptions,
  paymentTypeOptions,
  userType,
  paymentType,
  transactionTypes,
} from '../../../assets/helpers/options';
import { ActionButton } from '../../common/Buttons/Buttons.jsx';
import './AffiliationsDB.scss';
import {
  capitalize,
  filterParams,
  getCorrectDate,
  parseUrl,
  filterVehicleUse,
  validateRCVData,
  filterOptionById,
  filterRCVOptions,
  displayMembershipCode,
} from '../../../assets/helpers/funciones';
import { Input } from '../../common/Forms/Input/Input.jsx';
import { LoadSpinner } from '../../common/LoadSpinner/LoadSpinner.jsx';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
const itemsPerpage = [10, 25, 50, 100, 200, 500];
const ACTIVE_DISCOUNT_RENEWAL_LANDING = 'Renewal';

const maskAvailableMemberships = (options = []) =>
  options.map((option) => ({
    ...option,
    name: capitalize(displayMembershipCode(option?.name || option?.code)),
  }));

export const MultipleRenewal = () => {
  const { t } = useTranslation();
  const history = useHistory();
  // const [dollarRate, setDollarRate] = useState('');
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [economicActivitiesOptions, setEconomicActivitiesOptions] = useState(
    []
  );
  const [salesChannelOptions, setSalesChannelOptions] = useState([]);
  const [usageOptions, setUsageOptions] = useState([]);
  const [allPaymentTypesOptions, setAllPaymentTypesOptions] = useState([
    ...paymentTypeOptions,
    {
      name: paymentType?.CASHEA,
      _id: paymentType?.CASHEA,
    },
    {
      name: 'Cashea Link',
      _id: paymentType?.CASHEA_LINK,
    },
  ]);
  const [showCartModal, setShowCartModal] = useState({
    isOpen: false,
    type: '',
  });

  const {
    register,
    formState: { errors },
    setValue,
    watch,
    reset,
    control,
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schemas.updateNewMembershipClient(t)),
  });

  const {
    register: register2,
    formState: { errors: errors2 },
    watch: watch2,
    control: control2,
    setValue: setValue2,
    handleSubmit: handleSubmit2,
  } = useForm({
    resolver: yupResolver(schemas.totalToPayClientSchema(t)),
  });

  const {
    register: register3,
    formState: { errors: errors3 },
    setValue: setValue3,
    watch: watch3,
    reset: reset3,
    handleSubmit: handleSubmit3,
  } = useForm({
    resolver: yupResolver(schemas.editRCVClient(t)),
  });

  const [editClientModal, setEditClientModal] = useState({
    isOpen: false,
    selected: '',
  });

  const [editRCVModal, setEditRCVModal] = useState({
    isOpen: false,
    type: '',
  });

  const [membershipsDatatable, setMembershipsDatatable] = useState({
    limit: itemsPerpage[2],
    offset: 0, //Elementos que ya pasaron la pagina
    data: [],
    count: 0, //Cantidad de elementos
    page: 1,
    dateFrom: '',
    dateTo: '',
    isLoading: false,
    searchParam: '',
  });
  const autoApplyExecutedRef = useRef(false);
  const autoApplyRunningRef = useRef(false);
  const activeRenewalDiscountCodeRef = useRef({
    loaded: false,
    code: '',
  });

  useEffect(() => {
    getEconomicActivities();
    getSalesVehicleClasses();
    validatePaymentTypeOptions();
    getRenewalCart();
    getSalesChannel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    membershipsDatatable?.page,
    membershipsDatatable?.offset,
    membershipsDatatable?.limit,
    membershipsDatatable?.type,
  ]);

  useEffect(() => {
    // getDollarRate();
    setValue2('paymentDate', moment(new Date()).format('YYYY-MM-DD'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membershipsDatatable?.data]);

  const filteOptionsFunction = (options) => {
    options = options.filter(
      (o) => ![paymentType?.CASHEA, paymentType?.CASHEA_LINK]?.includes(o?._id)
    );

    return options;
  };

  const getSalesChannel = () => {
    saleChannelService
      .getSalesChannel()
      .then((response) => {
        if ([200, 201].includes(response?.status)) {
          setSalesChannelOptions(response?.data?.saleChannels);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const validatePaymentTypeOptions = () => {
    const user = authService?.getUser();

    let filterOptions = [...allPaymentTypesOptions];

    if (
      ![
        salesRoles?.SALES_ADMIN,
        salesRoles?.SALES_HUNTER,
        salesRoles?.SALES_FARMER,
        salesRoles?.SALES_COUNTER,
        salesRoles?.EVENTS,
        salesRoles?.SALES_KEY_ACCOUNTS,
      ]?.includes(authService?.getUserType()) ||
      (user?.roles[0]?.code === salesRoles?.SALES_COUNTER &&
        user?.type !== userType?.INTERNO) ||
      (user?.roles[0]?.code === salesRoles?.SALES_COUNTER &&
        user?.type === userType?.INTERNO)
    ) {
      filterOptions = filteOptionsFunction(filterOptions);
    }

    if (!casheaLinkAllowedRoles.includes(authService?.getUserType())) {
      filterOptions = filterOptions.filter(
        (o) => o?._id !== paymentType?.CASHEA_LINK
      );
    }

    setAllPaymentTypesOptions(filterOptions);
  };

  const getRenewalCart = () => {
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    membershipService
      .getRenewalCart()
      .then((response) => {
        if (response.status === 200) {
          const cartItems = (response?.data?.items || []).map((item) => ({
            ...item,
            availableMemberships: maskAvailableMemberships(
              item?.availableMemberships
            ),
          }));

          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              data: cartItems,
              isLoading: false,
            };
          });

          let amount = 0;
          let amountBs = 0;

          for (let i = 0; i < cartItems?.length; i++) {
            amount = amount + cartItems[i]?.newMem?.priceInfo.finalPrice;
            amountBs =
              amountBs + cartItems[i]?.newMem?.priceInfo.finalPriceInBsS;
          }

          setValue2('amount', amount);
          setValue2('amountBs', amountBs.toFixed(2));

          if (!autoApplyExecutedRef.current && !autoApplyRunningRef.current) {
            autoApplyExecutedRef.current = true;
            applyActiveDiscountToRenewalCart(cartItems);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
          setMembershipsDatatable((prevState) => {
            return {
              ...prevState,
              isLoading: false,
            };
          });
        }
      })
      .catch(() => {});

    return true;
  };

  const shouldApplyActiveRenewalDiscount = (item) => {
    const accidentRate = (item?.memToRenew?.accidentRate || '')
      .toString()
      .trim()
      .toUpperCase();

    return ['ORO', 'PLATA'].includes(accidentRate);
  };

  const hasManualOrAppliedDiscountCode = (item) => {
    return Boolean(
      item?.newMem?.discountCode?.code || item?.newMem?.discountCode
    );
  };

  const getValidActiveRenewalDiscountCode = async () => {
    if (activeRenewalDiscountCodeRef.current.loaded) {
      return activeRenewalDiscountCodeRef.current.code;
    }

    try {
      const activeDiscountResponse = await discountService.getActiveDiscount(
        filterParams({ landing: ACTIVE_DISCOUNT_RENEWAL_LANDING })
      );

      if (activeDiscountResponse?.status !== 200) {
        activeRenewalDiscountCodeRef.current = { loaded: true, code: '' };
        return '';
      }

      const discountCode = activeDiscountResponse?.data?.discountCode?.code;

      if (!discountCode) {
        activeRenewalDiscountCodeRef.current = { loaded: true, code: '' };
        return '';
      }

      const validateDiscountResponse = await giftCardService.validateDiscount(
        'discountCodes',
        filterParams({
          code: discountCode,
          type: 'renewal',
        })
      );

      if (![200, 201].includes(validateDiscountResponse?.status)) {
        activeRenewalDiscountCodeRef.current = { loaded: true, code: '' };
        return '';
      }

      const normalizedCode = discountCode.toUpperCase();
      activeRenewalDiscountCodeRef.current = {
        loaded: true,
        code: normalizedCode,
      };
      return normalizedCode;
    } catch (error) {
      console.log('MultipleRenewal: getValidActiveRenewalDiscountCode', error);
      activeRenewalDiscountCodeRef.current = { loaded: true, code: '' };
      return '';
    }
  };

  const applyActiveDiscountToRenewalCart = async (cartItems = []) => {
    autoApplyRunningRef.current = true;

    const eligibleMemberships = cartItems.filter((item) => {
      const membershipId = item?.memToRenew?._id;

      return (
        membershipId &&
        shouldApplyActiveRenewalDiscount(item) &&
        !hasManualOrAppliedDiscountCode(item)
      );
    });

    if (!eligibleMemberships.length) {
      autoApplyRunningRef.current = false;
      return;
    }

    const activeDiscountCode = await getValidActiveRenewalDiscountCode();

    if (!activeDiscountCode) {
      autoApplyRunningRef.current = false;
      return;
    }

    const results = await Promise.allSettled(
      eligibleMemberships.map((item) =>
        membershipService.updateRenewalCart(
          { discountCode: activeDiscountCode },
          item?.memToRenew?._id
        )
      )
    );

    let appliedCount = 0;

    results.forEach((result, index) => {
      if (result.status === 'fulfilled' && result.value?.status === 200) {
        appliedCount += 1;
      }
    });

    if (appliedCount > 0) {
      notify(
        'Se aplico descuento activo de renovacion automaticamente',
        'info'
      );
      getRenewalCart();
    }

    autoApplyRunningRef.current = false;
  };

  // const getDollarRate = async () => {
  //   rateService
  //     .getDollarRate()
  //     .then((response) => {
  //       if (response.status === 200) {
  //         setDollarRate(response?.data?.rate);
  //       } else {
  //         notify(`${response.message}` || 'error', 'error');
  //       }
  //     })
  //     .catch(() => { });
  // };

  const validateRCVValyes = () => {
    let isValid = true;

    for (let i = 0; i < membershipsDatatable?.data.length; i++) {
      if (!validateRCVData(membershipsDatatable?.data[i]?.newMem)) {
        isValid = false;
      }
    }
    return isValid;
  };

  const redirectPayment = handleSubmit2(async (data) => {
    let paymentDate = watch2('paymentDate');
    sessionStorage.setItem('paymentDate', paymentDate);
    if (validateRCVValyes()) {
      let url = `/afiliations/payment/${
        membershipsDatatable?.data[0]?.newMem?._id
      }/${transactionTypes.MULTIPLE_RENEWAL}/${parseUrl(data?.paymentType)}`;
      history.push(url);
    } else {
      notify(
        'Por favor complete los campos de RCV de todas las membresias',
        'error'
      );
    }
  });

  const updateCustomer = handleSubmit(async (data) => {
    data.membership = editClientModal.selected.newMem._id;
    setMembershipsDatatable((prevState) => {
      return {
        ...prevState,
        isLoading: true,
      };
    });

    customerService
      .updateCustomer(
        filterParams(data),
        editClientModal.selected.newMem.customer._id
      )
      .then((response) => {
        if (response.status === 200) {
          handleEditModal();
          notify('Cliente actualizado', 'success');
          getRenewalCart();
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
    return true;
  });

  const updateRCVClient = handleSubmit3(async (data) => {
    updateRenewalCart(data, editRCVModal.selected.memToRenew._id).then(
      (response) => {
        handleEditRCVModal();
        getRenewalCart();
      }
    );
  });

  const handleCartModal = (membership, action) => {
    if (membership) {
      setShowCartModal((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          type: action,
          membership: membership?.memToRenew,
          newMem: membership?.newMem,
        };
      });
    } else {
      setShowCartModal((prevState) => {
        return {
          ...prevState,
          isOpen: false,
          type: '',
          membership: '',
          newMem: '',
        };
      });
    }
  };

  const removeFromCart = () => {
    membershipService
      .removeFromCart(showCartModal?.membership?._id)
      .then((response) => {
        if (response.status === 200) {
          notify('Membresia removida del carrito de renovaciones', 'success');
          handleCartModal();
          getRenewalCart();
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch((error) => {});
  };

  const handleCheckbox = (name, value, index) => {
    const membershipId = membershipsDatatable?.data[index]?.memToRenew._id;
    let data = {};
    data[name] = !value;
    updateRenewalCart(data, membershipId);
  };

  const handleSelect = (name, value, index) => {
    let plan = filterOptionById(
      membershipsDatatable?.data[index].availableMemberships,
      value
    );
    let data = {};

    // Disable the extended tow checkbox if the selected plan does not allow it
    if (name === 'newPlan' && !planAllowsUnlimitedTow(plan?.code)) {
      handleCheckbox('useExtendedTow', true, index);
    }

    if (name === 'rcv') {
      // Reset the RCV card flag whenever RCV selection changes
      data.hasRcvCard = false;
    }

    const membershipId = membershipsDatatable?.data[index]?.memToRenew._id;
    data[name] = value;
    if (value || name === 'rcv') {
      updateRenewalCart(data, membershipId);
    }
  };

  const handleInput = (name, value, index) => {
    const membershipId = membershipsDatatable?.data[index]?.memToRenew._id;
    let data = {};
    data[name] = typeof value === 'string' ? value.trim() : value;
    updateRenewalCart(data, membershipId);
  };

  const updateRenewalCart = (data, membershipId) => {
    return membershipService
      .updateRenewalCart(data, membershipId)
      .then((response) => {
        if (response.status === 200) {
          getRenewalCart();
          notify('Campo actualizado', 'success');
          return true;
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const getSalesVehicleClasses = () => {
    vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          setVehicleClassesOptions(response?.data?.classes);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const handleEditModal = (membership) => {
    if (membership) {
      setEditClientModal((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          selected: membership,
        };
      });

      setValue(
        'firstName',
        capitalize(membership?.newMem?.customer?.firstName)
      );
      setValue('lastName', capitalize(membership?.newMem?.customer?.lastName));
      setValue(
        'identificationType',
        membership?.newMem?.customer?.identificationType
      );
      setValue('identification', membership?.newMem?.customer?.identification);
      setValue('email', membership?.newMem?.customer?.email.toLowerCase());
      setValue('phonePrefix', membership?.newMem?.customer?.phonePrefix);
      setValue('phoneNumber', membership?.newMem?.customer?.phoneNumber);
      setValue('gender', membership?.newMem?.customer?.gender);
      setValue('optionalEmail', membership?.newMem?.customer?.optionalEmail);
      setValue(
        'optionalPhonePrefix',
        membership?.newMem?.customer?.optionalPhonePrefix
      );
      setValue(
        'optionalPhoneNumber',
        membership?.newMem?.customer?.optionalPhoneNumber
      );
      setValue('maritalStatus', membership?.newMem?.customer?.maritalStatus);
      setValue(
        'birthday',
        getCorrectDate(membership?.newMem?.customer?.birthday)
      );
    } else {
      setEditClientModal((prevState) => {
        return {
          ...prevState,
          isOpen: false,
          selected: '',
        };
      });
      reset();
    }
  };

  const handleEditRCVModal = (membership) => {
    let options = [];

    options = filterVehicleUse(membership, vehicleClassesOptions);
    setUsageOptions(options);

    if (membership) {
      setEditRCVModal((prevState) => {
        return {
          ...prevState,
          isOpen: true,
          selected: membership,
        };
      });

      setValue3('bodySerial', membership?.newMem?.vehicleData.bodySerial);
      setValue3('engineSerial', membership?.newMem?.vehicleData.engineSerial);
      setValue3('seats', membership?.newMem?.vehicleData.seats);
      setValue3('vehicleUsage', membership?.newMem?.vehicleData.vehicleUsage);
      setValue3('profession', membership?.newMem?.customer.profession);
      setValue3(
        'economicActivity',
        membership?.newMem?.customer.economicActivity
      );
      setValue3('titleNumber', membership?.newMem?.vehicleData.titleNumber);
    } else {
      setEditRCVModal((prevState) => {
        return {
          ...prevState,
          isOpen: false,
          selected: '',
        };
      });
      setUsageOptions([]);
      reset3();
    }
  };

  const getEconomicActivities = () => {
    economicActivitiesService
      .getEconomicActivities()
      .then((response) => {
        if (response.status === 200) {
          setEconomicActivitiesOptions(response?.data?.activities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const handlePaymentDateRate = () => {
    let params = {
      currency: 'USD',
      date: watch2('paymentDate')
        ? moment(watch2('paymentDate')).format('YYYY-MM-DD')
        : '',
      limit: 1,
    };
    currencyRateService
      .getCurrencyRates(params)
      .then((response) => {
        if (response.status === 200) {
          let rate = response?.data?.result[0]?.rate;
          setValue2('amountBs', (watch2('amount') * rate).toFixed(2));
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
    return true;
  };

  const removeAllDiscounts = (memToRenew) => {
    for (let i = 0; i < memToRenew.length; i++) {
      membershipService
        .updateRenewalCart(
          { useRenewalDiscount: false },
          memToRenew[i]?.memToRenew?._id
        )
        .then((response) => {
          if (response.status === 200) {
          } else {
            notify(`${response.message}` || 'error', 'error');
          }
        })
        .catch(() => {});
    }
  };

  const handleRemoveDiscount = () => {
    if (
      [
        paymentType.CASHEA,
        paymentType.CASHEA_LINK,
        paymentType.FINANCIADO,
      ]?.includes(watch2('paymentType'))
    ) {
      setMembershipsDatatable((prevState) => {
        return {
          ...prevState,
          isLoading: true,
        };
      });

      let memToRenew = membershipsDatatable?.data.filter(
        (m) => m?.useRenewalDiscount
      );
      Promise.allSettled([removeAllDiscounts(memToRenew)]).then((r) => {
        notify(
          `Descuentos removidos para pago ${watch2('paymentType')}`,
          'success'
        );
        setTimeout(() => {
          getRenewalCart();
        }, 2500);
      });
    }
  };

  const table = {
    header: multipleRenewalTableHeader,
    data: membershipsDatatable,
    options: {
      salesChannelOptions: salesChannelOptions,
      KMServiceOptions: KMServiceOptions,
      KMOderOptions: KMOderOptions,
      rcvOptions: filterRCVOptions(rcvOptions),
      vehicleClassesOptions: vehicleClassesOptions,
      currentPaymentType: watch2('paymentType'),
    },
    actions: {
      handleEditModal: handleEditModal,
      handleEditRCVModal: handleEditRCVModal,
      handleCartModal: handleCartModal,
      handleCheckbox: handleCheckbox,
      handleSelect: handleSelect,
      handleInput: handleInput,
    },
  };

  return (
    <>
      <LoadSpinner show={membershipsDatatable?.isLoading} />
      <CartModal
        modal={showCartModal}
        action={{
          handleCartModal: handleCartModal,
          removeFromCart: removeFromCart,
        }}
        newMem={showCartModal?.newMem?.membershipId}
      />
      <EditClientModal
        modal={editClientModal}
        register={register}
        errors={errors}
        watch={watch}
        action={updateCustomer}
        handleModal={handleEditModal}
        control={control}
        options={{
          phoneCodes: phoneCodes,
          idCodes: idCodes,
          genderOptions: genderOptions,
          civilStateOptions: civilStateOptions,
        }}
      />

      <EditRCVModal
        modal={editRCVModal}
        register={register3}
        errors={errors3}
        watch={watch3}
        action={updateRCVClient}
        handleModal={handleEditRCVModal}
        options={{
          economicActivitiesOptions: economicActivitiesOptions,
          usageOptions: usageOptions,
        }}
      />
      <Header />
      <div className="service-with-container container">
        <div className="buttons-container">
          <h1 className="title-component">
            Carrito de Renovaciones {membershipsDatatable?.data?.length}
          </h1>
        </div>
        <MultipleAffiliationTable
          table={table}
          header={multipleRenewalTableHeader}
          data={membershipsDatatable}
        />
        <MultipleRenewalPrice
          action={redirectPayment}
          handlePaymentDateRate={handlePaymentDateRate}
          register={register2}
          errors={errors2}
          control={control2}
          options={{ allPaymentTypesOptions: allPaymentTypesOptions }}
          handleRemoveDiscount={handleRemoveDiscount}
        />
      </div>
    </>
  );
};

const MultipleRenewalPrice = (props) => {
  const {
    register,
    errors,
    options,
    action,
    control,
    handlePaymentDateRate,
    handleRemoveDiscount,
  } = props;
  return (
    <div className="order-card">
      <div className="order-card-header">
        <div>
          <h5>Total a pagar</h5>
        </div>
      </div>
      <div className="row" style={{ width: '100%' }}>
        <Input
          bootstrap={'col-2'}
          label={'Monto USD *'}
          type={'number'}
          name={`amount`}
          register={register}
          placeholder={''}
          disabled={true}
          errors={errors?.[`amount`]?.message}
        />
        <Input
          bootstrap={'col-2'}
          label={'Monto BS *'}
          type={'number'}
          name={`amountBs`}
          register={register}
          placeholder={''}
          disabled={true}
          errors={errors?.[`amountBs`]?.message}
        />
        <Input
          bootstrap={'col-2'}
          label={'Fecha de Pago *'}
          type={'birthday'}
          name={'paymentDate'}
          register={register}
          capitalizeOff={true}
          placeholder={''}
          control={control}
          errors={errors?.paymentDate?.message}
          onChange={() => handlePaymentDateRate()}
        />
        <Input
          bootstrap={'col-2'}
          label={'Tipo de Pago'}
          type={'select'}
          options={options?.allPaymentTypesOptions}
          name={`paymentType`}
          register={register}
          placeholder={''}
          errors={errors?.[`paymentType`]?.message}
          onChange={() => handleRemoveDiscount()}
        />
        <div className="col-2">
          <div style={{ marginTop: '32px' }}>
            <ActionButton label="Pagar" action={action} />
          </div>
        </div>
      </div>
    </div>
  );
};
